<template>
  <div>
    <CModal title="Mensagem" :show.sync="largeModal" :footer-wrapper="false">
      <CSelect
        :value.sync="profissionalSelecionado"
        :options="listaProfissionais"
        required
        v-model="profissionalSelecionado"
        prepend="Profissional"
        invalid-feedback="Nome é obrigatório"
      >
        <!-- <template #append-content>
          <CIcon name="cil-badge" />
        </template> -->
      </CSelect>

      <CTextarea
        placeholder="Mensagem"
        horizontal
        rows="5"
        cols="20"
        v-model="texto"
      />

      <CButton color="success" @click="enviarMensagem()"
        >Enviar Mensagem</CButton
      >
      <CButton color="info" class="m-2" @click="voltar()">Voltar</CButton>
    </CModal>
    <CDropdown
      inNav
      class="c-header-nav-items"
      placement="bottom-end"
      add-menu-classes="pt-0"
    >
      <template #toggler>
        <CHeaderNavLink>
          <div class="c-avatar">
            <CImg
              src="../assets/fundoAllto.d74dcfe7.png"
              class="c-avatar-img"
            />
          </div>
        </CHeaderNavLink>
      </template>
      <CDropdownHeader tag="div" class="text-center" color="light">
        <!-- <strong>teste</strong> -->
      </CDropdownHeader>
      <CDropdownHeader tag="div" class="text-center" color="light">
        <strong>{{ idUser }}</strong>
      </CDropdownHeader>
      <CDropdownItem
        @click="abreCampoMensagem()"
        v-if="idUser != 'Profissional'"
      >
        <CIcon name="cil-envelope-closed" />Mensagem
      </CDropdownItem>
      <CDropdownItem @click="logout">
        <CIcon name="cil-lock-locked" />Logout
      </CDropdownItem>
    </CDropdown>
  </div>
</template>

<script>
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      largeModal: false,
      texto: "",
      profissionalSelecionado: "",
      listaProfissionais: [{ label: "", value: "" }],
      mensagem: "",

      idUser: "",
    };
  },

  methods: {
    logout() {
      this.$router.push("/login");
    },
    enviarMensagem() {
      this.$http
        .post(
          `${process.env.VUE_APP_API_BASE_URL}usuario/cadastrar-notificacoes`,
          {
            idProfissional: this.profissionalSelecionado,
            typeNotification: "Mensagem",
            idUser: localStorage.getItem("id"),
            text: this.texto,
            typeUser: localStorage.getItem("type_name"),
          }
        )
        .then(() => {
          this.largeModal = false;
        });
    },
    abreCampoMensagem() {
      this.largeModal = true;
    },
    update() {},
    voltar() {
      this.largeModal = false;
    },
    listarProfissionais() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}profissionais`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.listaProfissionais.push({
              label: item.name,
              value: item.id,
            });
          });
        });
    },
  },
  mounted() {
    this.idUser = localStorage.getItem("type_name");
    this.listarProfissionais();
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
.modal-content .modal-footer {
  display: none !important;
}
</style>
